export default "__VITE_ASSET__CS_VeVZl__"